import React, { useMemo } from "react";
import ShowcaseSliderRow from "./ShowcaseSliderRow";

interface FastProductShowcaseProps {
  config: string; // Passed from PHP as JSON string
}

const FastProductShowcase: React.FC<FastProductShowcaseProps> = ({
  config,
}) => {
  const parsedConfig = useMemo(() => {
    try {
      return JSON.parse(config);
    } catch (e) {
      console.error("Failed to parse FastProductShowcase config", e);
      return [];
    }
  }, [config]);

  if (!parsedConfig || parsedConfig.length === 0) return null;

  return (
    <div className="fast-product-showcase__sliders">
      {parsedConfig.map((row: any, index: number) => (
        <ShowcaseSliderRow key={index} config={row} />
      ))}
    </div>
  );
};

export default FastProductShowcase;
